import { render, staticRenderFns } from "./inviteFriends.vue?vue&type=template&id=d2122532&scoped=true"
import script from "./inviteFriends.vue?vue&type=script&lang=js"
export * from "./inviteFriends.vue?vue&type=script&lang=js"
import style0 from "./inviteFriends.vue?vue&type=style&index=0&id=d2122532&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2122532",
  null
  
)

export default component.exports